import React, { useContext } from 'react'
import Tip from 'app/React/Components/misc/Tip'
import clx from 'classnames'
import { FeatureFlag } from 'utils/feature-flag'
import OptionStep3 from "app/React/Components/Form/Step3/OptionStep3";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function SettingStep3(props) {
  const {
    colorSettingId,
    currentEngineTransmission,
    order
  } = useContext(ConfiguratorContext)

  const setting = props.setting
  const options = Array.isArray(setting.options) ? { ...setting.options } : setting.options

  const optionValues = Object.values(options).filter(option => {
    if (option.type === 'accessory-product' && !FeatureFlag.accessoryShop()) {
      return false
    }

    if (option.hide_on === order.paymentType || option.hide_on === 'all') {
      return false
    }

    if (option.engines_required?.length > 0) {
      if (!option.engines_required.includes(currentEngineTransmission.engine_id)) {
        return false
      }
    }

    if (option.transmission_required?.length > 0) {
      if (!option.transmission_required.includes(currentEngineTransmission.transmission_id)) {
        return false
      }
    }

    let colorId = order.configuration?.color?.id ?? 0
    const selectedColorId = colorSettingId !== null ? colorId.replace(colorSettingId + '_', '') : colorId
    if (option.colors_required?.length > 0) {
      if (!option.colors_required.includes(selectedColorId)) {
        return false
      }
    }

    return true
  })

  if (optionValues.length <= 0) {
    return null
  }

  const option_elements = optionValues.map((option, key) => (
    <OptionStep3
      key={key}
      option={option}
      layout={setting.layout}
      settingid={setting.id}
      onChange={props.onChange}
      checked={false}
      required={setting.required && setting.required !== '0'}
    />))

  if (
    optionValues.filter(
      (o) =>
        !(
          o.hide_on === order.paymentType ||
          o.hide_on === 'all' ||
          (!FeatureFlag.accessoryShop() && o.type === 'accessory-product')
        )
    ).length <= 0
  ) {
    return null
  }

  return (
    <>
      <div className={clx('setting', props.className)} data-setting-id={setting.id}>
        <h3 className='config-subtitle'>
          {setting.label}
          {typeof setting.description === 'string' && setting.description.length > 0 ? (
            <Tip button='Ok' content={setting.description}/>
          ) : null}
        </h3>
        <div className='config-radio' data-option-count={0}>
          {option_elements}
        </div>
      </div>
      <div className='config-seperator'/>
    </>
  )
}

SettingStep3.defaultProps = {
  onChange: null,
  className: ''
}
